import { render } from "./clapadd.vue?vue&type=template&id=87aa92fc&scoped=true&ts=true"
import script from "./clapadd.vue?vue&type=script&lang=ts"
export * from "./clapadd.vue?vue&type=script&lang=ts"

import "./clapadd.vue?vue&type=style&index=0&id=87aa92fc&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87aa92fc"]])

export default __exports__